import { type Vector3Like } from 'three'

export const OrbitControlsSensitivity = {
  rotateSpeed: 0.3,
  zoomSpeed: 0.3,
  panSpeed: 0.3,
}

export const ScaleFactor = 1.7 // 1 Three.js unit = 1.70 cm

export const InchesPerCm = 2.54

export const V2_SCENE_OFFSET: Vector3Like = { x: 0, y: -2.5, z: 0 }

export const V2_SKIN_EMISSIVE_BOOST = 0.35
